import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    {
      name: 'GitHub',
      icon: 'fab fa-github',
      url: 'https://github.com/7ima-SR'
    },
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin',
      url: 'https://www.linkedin.com/in/eng-ibrahim-elsaied/'
    },
    {
      name: 'Twitter',
      icon: 'fab fa-twitter',
      url: 'https://x.com/ibrahimelsaee14'
    },
    {
      name: 'Instagram',
      icon: 'fab fa-instagram',
      url: 'https://www.instagram.com/7_im_a_?igsh=bWNzdnV3bmpvaG5z'
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
            >
              <i className={social.icon}></i>
            </a>
          ))}
        </div>
        
        <div className="footer-text">
          <p>Living, learning, & leveling up one day at a time.</p>
        </div>

        <div className="copyright">
          <p>&copy; {currentYear} Ibrahim Elsaied (SR). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 